import PropTypes from 'prop-types';
import React from 'react';
import { isBrowser } from '../../utils/environment';
import {
    ImportantMessageIcon,
    StyledImportantMessage,
    StyledImportantMessageContainer,
    StyledImportantMessageTextContainer,
    StyledImportantMessageText,
    StyledImportantMessageLink,
    StyledImportantMessageCloseButton,
    StyledImportantMessageVisuallyHidden,
    StyledImportantMessageCloseIcon,
} from './ImportantMessage.styles';

export const IMPORTANT_MESSAGE_TYPES = {
    VMA: 'VMA',
    TMA: 'TMA',
};

const ImportantMessage = ({ type, combinedId, text, link, linkText, isRead, onClose, hasCookie }) => {
    const typeUpperCase = type.toUpperCase();

    if (!isBrowser() || isRead) {
        return null;
    }

    return (
        <StyledImportantMessageContainer messageType={typeUpperCase} hasCookie={hasCookie}>
            <StyledImportantMessage>
                <ImportantMessageIcon aria-hidden="true" iconType={typeUpperCase} />
                <StyledImportantMessageTextContainer>
                    <StyledImportantMessageText data-rt="important-message">
                        {text}{' '}
                        {link && (
                            <StyledImportantMessageLink href={link}>
                                {linkText || 'Läs mer'}
                            </StyledImportantMessageLink>
                        )}
                    </StyledImportantMessageText>
                </StyledImportantMessageTextContainer>
                {combinedId && (
                    <StyledImportantMessageCloseButton
                        type="button"
                        data-rt="close-important-message"
                        onClick={() => onClose(combinedId)}
                    >
                        <StyledImportantMessageCloseIcon aria-hidden="true" />
                        <StyledImportantMessageVisuallyHidden>
                            Stäng meddelande
                        </StyledImportantMessageVisuallyHidden>
                    </StyledImportantMessageCloseButton>
                )}
            </StyledImportantMessage>
        </StyledImportantMessageContainer>
    );
};

ImportantMessage.propTypes = {
    type: PropTypes.oneOf([IMPORTANT_MESSAGE_TYPES.VMA, IMPORTANT_MESSAGE_TYPES.TMA]).isRequired,
    text: PropTypes.string.isRequired,
    link: PropTypes.string,
    linkText: PropTypes.string,
};

export default ImportantMessage;
